import { defaultApi } from '@/plugins/api/defaultApi'
import store from '@/store'
let isLoading = false
let isLoaded = false

const st = {
  name: 'code/bank',
  namespaced: true,
  state: {
    banks: [],
  },
  getters: {
    getBanks(state) {
      store.dispatch(`${st.name}/init`)
      return state.banks
    },
    getBank: (state) => (code) => {
      store.dispatch(`${st.name}/init`)
      return state.banks.find((el) => el.bank === code)
    },
  },
  mutations: {
    setBanks(state, banks) {
      state.banks = banks
    },
  },
  actions: {
    async init({ state, commit }) {
      if (isLoading || isLoaded) {
        return state.banks
      }
      try {
        isLoading = true
        const { data } = await defaultApi.getBankCodes()
        commit('setBanks', data)
        isLoaded = true
        return data
      } finally {
        isLoading = false
      }
    },
    async getBanks({ state, dispatch }) {
      if (state.banks.length == 0) {
        return await dispatch('init')
      }
      return state.banks
    },
    async getBank({ state }, code) {
      if (state.banks.length == 0) {
        return await dispatch('init')
      }
      console.log(
        code,
        state.banks.find((el) => el.bank === code),
      )
      return state.banks.find((el) => el.bank === code)
    },
    async getBankName({ dispatch }, code) {
      const { name } = await dispatch('getBank', code)
      return name
    },
  },
}

export default st
